package com.nonopn.skywatcher.common.api

import kotlinx.serialization.Serializable

@Serializable
data class SavedSession<T>(
    val expiresAt: Long,
    val token: String? = null,
    val specificData: T? = null
)
